import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { SplashScreen } from "src/components/loading-screen";
import { persistor, RootState } from "src/store/store";

interface PublicRouteProps {
  children: React.ReactNode;
}

const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp < Date.now() / 1000;
  } catch {
    return true;
  }
};

export default function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, token } = useSelector(
    (state: RootState) => state.auth
  );
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Check if persist has already rehydrated
    if (persistor.getState().bootstrapped) {
      setChecked(true);
      return;
    }

    const unsubscribe = persistor.subscribe(() => {
      const { bootstrapped } = persistor.getState();
      if (bootstrapped) {
        setChecked(true);
        unsubscribe();
      }
    });
    return () => unsubscribe();
  }, []);

  // Additional safety check for token validity
  const isReallyAuthenticated =
    isAuthenticated && token && !isTokenExpired(token);

  if (!checked) {
    return <SplashScreen />;
  }
  if (isReallyAuthenticated) {
    return <Navigate to="dashboard" replace />;
  }
  return <>{children}</>;
}
